module.exports = __webpack_public_path__ + "img/bloc-note.ad87faa8.png";